import React, { useEffect } from 'react';
import './OdWelcome.scss';
import { useDispatch, useSelector } from 'react-redux';
import OdButton from '../../OdButton/OdButton';
import { getOdUserInfoRequest } from '../../../../actionCreators/user';

const OdWelcome = ({ data }) => {
  const { message, ctaLabel, ctaLink } = data;
  const { result: user, loading, error } = useSelector(state => state.user);
  const dispatch = useDispatch();

  // Move this to mobile header
  useEffect(() => {
    dispatch(getOdUserInfoRequest());
  }, []);

  if (user) {
    return (
      <div className="odWelcome">
        <h2 className="odWelcome__greet">Good Day {user?.firstName}</h2>
        <p className="odWelcome__message">{message}</p>
        <OdButton href={ctaLink} label={ctaLabel} />
      </div>
    );
  }

  return null;
};

export default OdWelcome;
